import { createSlice, PayloadAction } from "@reduxjs/toolkit";

interface FiltersState {
  orderId: string;
  supplier: string;
  statusOR: string;
  statusSN: string;
  statusINV: string;
  // add more if needed
}

const initialState: FiltersState = {
  orderId: "",
  supplier: "",
  statusOR: "all",
  statusSN: "all",
  statusINV: "all",
};

const filtersSlice = createSlice({
  name: "filters",
  initialState,
  reducers: {
    setFilters: (state, action: PayloadAction<Partial<FiltersState>>) => {
      return { ...state, ...action.payload };
    },
    resetFilters: () => initialState,
  },
});

export const { setFilters, resetFilters } = filtersSlice.actions;
export default filtersSlice.reducer;
